import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-shared-tournament-situation-filter',
    templateUrl: './shared-tournament-situation-filter.component.html',
    styleUrls: ['./shared-tournament-situation-filter.component.scss'],
})
export class SharedTournamentSituationFilterComponent implements OnInit {
    @Output() onFilterChange: EventEmitter<any> = new EventEmitter();

    filterTournamentSituation: string = '0';

    /**
     * Opções possíveis de seleção nos filtros
     */
    filterTournamentSituationOptions = [
        {
            label: 'Todos',
            filter: '0',
        },
        {
            label: 'Planejado',
            filter: '1',
        },
        {
            label: 'Inscrições Abertas',
            filter: '3',
        },
        {
            label: 'Em andamento',
            filter: '5',
        },
        {
            label: 'Encerrado',
            filter: '9',
        },
    ];

    constructor() {}

    ngOnInit(): void {}

    changeFilter({ filter }) {
        this.filterTournamentSituation = filter;
        this.onFilterChange.emit(filter);
    }
}
